import React from "react";
import "./DomainStepsSection.css";

const steps = [
  "Enter your brand name or business idea in the search box.",
  "Compare available extensions like .com, .in, .net, .shop, and more.",
  "Choose a short, clear, and easy-to-remember domain name.",
  "Add your selected domain to cart and review the first-year price.",
  "Complete checkout securely and save the domain inside your account.",
  "Connect DNS, email, SSL, and hosting whenever your business is ready.",
];

const DomainStepsSection = () => {
  return (
    <section className="ds-section">
      <div className="ds-container">
        <div className="ds-content">
          <span>Simple process</span>
          <h2>Start your domain journey in minutes</h2>
          <p>
            Find the right name, secure it safely, and connect it with your
            website, email, and hosting tools from one clean platform.
          </p>
        </div>

        <div className="ds-list">
          {steps.map((step, index) => (
            <div className="ds-step" key={step}>
              <strong>{String(index + 1).padStart(2, "0")}</strong>
              <p>{step}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DomainStepsSection;  